import React from "react";
import { CircularProgress } from "@mui/material";
import styles from "./ReqList.module.css";

export default function ReqListLoader() {
	return (
		<div className={styles["req-list__empty-state"]}>
			<CircularProgress />
		</div>
	);
}
